import { render, staticRenderFns } from "./Lesson10.vue?vue&type=template&id=baf069b0&scoped=true&"
import script from "./Lesson10.vue?vue&type=script&lang=js&"
export * from "./Lesson10.vue?vue&type=script&lang=js&"
import style0 from "./Lesson10.vue?vue&type=style&index=0&id=baf069b0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baf069b0",
  null
  
)

export default component.exports